import { render, staticRenderFns } from "./index.vue?vue&type=template&id=131831b2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=131831b2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131831b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131831b2')) {
      api.createRecord('131831b2', component.options)
    } else {
      api.reload('131831b2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=131831b2&scoped=true", function () {
      api.rerender('131831b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/CustomerServiceBot/index.vue"
export default component.exports